import React from "react";
import { EuiFlexGroup, EuiPanel } from "@elastic/eui";
import styled from "styled-components";

export const ProfileDetailsWrapper = styled(EuiPanel)`
    .profile-details__section-wrapper {
        padding: 20px;
    }
`;

export const ProfileEntitiesWrapper = styled(EuiPanel)`
    .euiTab__content svg {
        fill: ${(props) => props.theme.default.euiColorFullShade};
        width: 20px;
        height: 20px;
    }
`;

export const ProfileStatsEntityWrapper = styled(({ color, ...rest }) => <EuiFlexGroup {...rest} />)`
    background: ${(props) => props.color} 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px ${(props) => props.color}30;
    color: #fff;
    border-radius: 5px;

    .stats-value {
        color: #fff !important;
    }

    .euiHorizontalRule {
        opacity: 0.2;
    }

    .entityIcon__container {
        padding: 15px;
        background: #ffffff20;
        border-radius: 50%;

        svg {
            fill: #fff;
            width: 30px;
            height: 30px;
        }
    }
`;
